const initialProps = {
  curStock: [],
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "UPDATE_INVENTORY":
      return {
        ...state,
        curStock: action.payload,
      };
    default:
      return state;
  }
}
